<template>
  <div class="schedule-extra-list-component">
    <h2 v-if="extraSchedules.length > 0">
      {{ $tc("ETAB.PAGES.SURVEY.@SCHEDULE_TITLE", extraSchedules.length) }}
    </h2>
    <section>
      <ScheduleCard v-for="schedule in extraSchedules" :key="schedule.getShiftId()" :schedule="schedule" />
    </section>
  </div>
</template>

<script>
import ScheduleCard from "@etab/components/survey/ScheduleCard.component.vue";

export default {
  components: {
    ScheduleCard,
  },
  props: {
    extraSchedules: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.schedule-extra-list-component {
  h2 {
    margin: 15px;
    color: $secondary;
  }

  > section {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 50px;

    > *:first-of-type {
      margin-top: -25px; // make the first child higher in order to aknowledge the avatar translateY
    }
  }
}
</style>
